import { notifyAndLogError } from 'src/UI/common/ui-helpers';
import { StepProps } from 'src/UI/drawer-flow/DrawerFlow';
import SelectTemplateStep from 'src/UI/drawer-flow/SelectTemplateStep';
import { useGenerateMeetingAgenda } from '../hooks/useGenerateMeetingAgenda';

type AgendaData = {
  client?: import('src/users').Client;
  selectedTemplateId?: string;
};

export default function AgendaSelectTemplateStep(props: StepProps<AgendaData>) {
  const { generateMeetingAgenda, isLoading } = useGenerateMeetingAgenda();

  const handleGenerateAgenda = async () => {
    if (!props.data.client) {
      throw new Error('Client not found');
    }
    try {
      await generateMeetingAgenda(props.data.client.id, {
        templateId: props.data.selectedTemplateId,
      });
      props.onSuccess();
    } catch (error) {
      notifyAndLogError('Error', 'Failed to generate agenda', error);
    }
  };
  return (
    <SelectTemplateStep
      {...props}
      type="MEETING_AGENDA"
      description="Please choose a template which Siesta AI will use to base the client specific agenda on."
      clientNameSuffix="agenda"
      continueText={isLoading ? 'Generating agenda' : 'Generate Agenda'}
      canGoForward={!isLoading}
      canGoBack={!isLoading}
      nextStep={handleGenerateAgenda}
      isSubmitting={isLoading}
    />
  );
}
